import { getI18nLocaleCode, languageName } from "@coworker/locales";

export const languageMapper = (locale: string) => {
  const i18n = getI18nLocaleCode(locale);
  const name = languageName(i18n);
  return { name, locale, i18n };
};
